import Avatar from "../Avatar/Avatar";
import Icon from "../Icon/Icon";
import React, {useRef, useState} from "react";
import {getUri, truchateString} from "../../utils/utils";
import FormItem from "../Form/FormItem/FormItem";
import {IoMdSend} from "react-icons/io";
import {useCommunity} from "../../redux/Reducers/CommunityComments";
import {useLikedComments} from "../../redux/Reducers/LikedCommentReducer";
import {AiFillLike, AiOutlineLike} from "react-icons/ai";
import useReply from "../../hooks/useReply";
import Spinner from "../Loaders/Spinner/Spinner";
import LoadMoreButton from "../Buttons/LoadMore/LoadMoreButton";
import {MdDelete, MdOutlineDelete} from "react-icons/md";
import {useSession} from "../../redux/Reducers/AuthReducer";
import {useAlterBox} from "../../Modals/AlertModal/Context";
import AlertModal from "../../Modals/AlertModal/AlertModal";
import ImagesBox from "../../pages/main/Community/components/images-Box";
import {getCommentType} from "../../utils/comment-type";

export function ReplyBox({className, onClickSend, ...props}) {

    return (
        <div className={`flex flex-row gap-2 mr-4 ${className}`}>
            <input

                className={"w-full outline-none border-[1px] text-sm rounded-lg px-4 py-1"}
                {...props}
            />
            <div
                onClick={onClickSend}
                className={"flex hover:bg-brand-900 rounded-lg cursor-pointer bg-brand-800 px-4 py-1 text-white gap-2 items-center"}>
                <IoMdSend className={"m-auto"}/>

            </div>
        </div>

    )
}


export default function Comment({className, comment, replies, isReply, onlyViewMode, deleteComment, ...props}) {
    const [readMore, setReadMore] = React.useState(false);
    const [showReplyBox, setShowReplyBox] = React.useState(false);
    const {likedListActions} = useLikedComments();
    const [likesReplyCount, setLikeReply] = React.useState({
        likes: comment?.total_likes,
        replies: comment?.total_replies || comment?.replies?.count || 0,
    });
    const [reply, isLoading, actions] = useReply();
    const [replyText, setReplyText] = React.useState("");
    const isFirsTime = React.useRef(true);
    const {session,authActions} = useSession();
    const [isAlertBoxOpen, setIsAlertBoxOpen] = useState(false);

    const images = comment?.images_list || [];


    function likeComment() {
        likedListActions.likeDislikeComment(comment?.id).then((res) => {
            setLikeReply({
                ...likesReplyCount,
                likes: res,
            })
        })
    }

    let sendMessage = () => {
        if (replyText.trim() === "") return;
        setReplyText("")
        actions.addReply(comment?.id, replyText).then((res) => {
            setLikeReply({
                ...likesReplyCount,
                replies: res?.totalReplies || reply?.replies?.length + 1,
            })

        })
    };

    return (
        <div className={`flex flex-col gap-4 px-4   ${className}`}>
            <AlertModal
                isAlertBoxOpen={isAlertBoxOpen}
                setIsAlertBoxOpen={setIsAlertBoxOpen}
                title={"Delete Comment"}
                message={"Are you sure you want to delete this comment?"}
                confirmButtonText={"Delete"}
                cancelButtonText={"Cancel"}
                onConfirm={() => {

                    if (deleteComment) deleteComment();
                }}

            />
            <div className={"flex gap-2 items-center"}>
                <Avatar size={"w-9 h-9"} src={getUri(comment?.posted_by?.dp_uri?.file)}/>
                <div className={"flex flex-col gap-2"}>
                    <p className={"font-semibold text-sm whitespace-nowrap"}>
                        {
                            truchateString(comment?.posted_by?.full_name || "Anonymous", 10)
                        }
                    </p>
                    {comment?.posted_by?.is_staff &&
                        <div className={"flex flex-row"}>
                            <p
                                className={"border-[1px] border-secondary-900 text-secondary-900 text-center rounded-full px-4 text-xxs"}
                            >
                                admin
                            </p>
                        </div>}
                </div>
                <div className={"flex-1"}/>
                <p className={"font-normal text-xs text-gray-400"}>
                    {
                        comment?.created_at?.date || "-"
                    }
                </p>
                {authActions.is_admin() || session?.profile?.id === comment?.posted_by?.id  ?
                    <MdOutlineDelete
                        onClick={() => {
                            setIsAlertBoxOpen(true);

                        }}
                        className={"cursor-pointer"}/> : null}


            </div>
            <div className={"bg-gray-100 flex flex-col gap-2 rounded-lg px-3 py-2 font-normal text-sm "}>
                <p>
                    {
                        truchateString(comment?.text || "-", readMore ? comment?.text?.length + 1 : 300)
                    }
                    {
                        comment?.text?.length > 100 && !readMore &&
                        <span className={"text-secondary-900 cursor-pointer"}
                              onClick={() => setReadMore(true)}>...read
                        more</span>

                    }
                </p>
                <div className={"inline-flex text-xxs mt-2"}>
                    <p style={{
                        color: getCommentType(comment?.comment_type)?.color,
                        borderColor: getCommentType(comment?.comment_type)?.color
                    }} className={"border-[1px] px-4 rounded-full"}>

                        {
                            getCommentType(comment?.comment_type)?.name
                        }
                    </p>
                </div>
            </div>
            <div className={"flex flex-row gap-2 flex-wrap"}>
                {
                    images.map((image, i) => (
                        <ImagesBox key={image?.id} data={image}/>
                    ))
                }
            </div>


            <div className={"flex gap-4 items-center justify-end "}>
                {!isReply && <div
                    onClick={() => {
                        setShowReplyBox(!showReplyBox);
                        if (isFirsTime.current) {
                            actions.FetchOldReplies(comment?.id);
                            isFirsTime.current = false;
                        }
                    }}
                    className={"flex gap-1 cursor-pointer justify-center items-center text-sm font-semibold text-[#5F5F5F] "}>
                    <Icon name={"reply"}/>
                    <p className={""}>
                        ({likesReplyCount?.replies}) Reply
                    </p>
                </div>}

                <div

                    onClick={likeComment}
                    className={`${likedListActions.isCommentLiked(comment?.id) ? "text-tertiary-900" : "text-[#5F5F5F]"} flex gap-1  cursor-pointer justify-center items-center text-sm font-semibold  `}>
                    {
                        !likedListActions.isCommentLiked(comment?.id) ? <AiOutlineLike className={"text-xl"}/>
                            : <AiFillLike className={"text-xl"}/>

                    }
                    <p className={""}>
                        ({likesReplyCount?.likes}) Like
                    </p>
                </div>

            </div>
            {
                showReplyBox && !onlyViewMode && authActions.hasActiveSubscription() &&
                <ReplyBox onClickSend={sendMessage} placeholder={"Reply.."} value={replyText}
                          className={"pl-3 lg:pl-12"}
                          onChange={(e) => setReplyText(e.target.value)}
                />
            }

            <div className={"flex flex-col gap-1 pl-3 lg:pl-10"}>
                {
                    reply?.results?.map((reply, index) => {
                        return <Comment

                            deleteComment={() => {
                                actions.deleteComment(reply?.id).then((res) => {
                                    setLikeReply({
                                        ...likesReplyCount,
                                        replies: res,
                                    })
                                })
                            }}

                            isReply={true} comment={reply} key={reply?.id}/>
                    })

                }
            </div>

            {
                isLoading && <div className={"w-full flex justify-center items-center"}><Spinner/></div>
            }
            {
                !isLoading ? reply?.next && <LoadMoreButton className={"text-sm"}
                                                            onClick={() => actions.FetchOldReplies(comment?.id)}
                /> : null
            }
        </div>

    )
}